import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Energyflat } from './energyflat.model';
import { EnergyflatPopupService } from './energyflat-popup.service';
import { EnergyflatService } from './energyflat.service';

@Component({
    selector: 'jhi-energyflat-delete-dialog',
    templateUrl: './energyflat-delete-dialog.component.html'
})
export class EnergyflatDeleteDialogComponent {

    energyflat: Energyflat;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private energyflatService: EnergyflatService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['energyflat']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.energyflatService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'energyflatListModification',
                content: 'Deleted an energyflat'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-energyflat-delete-popup',
    template: ''
})
export class EnergyflatDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private energyflatPopupService: EnergyflatPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.energyflatPopupService
                .open(EnergyflatDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/energyflat/energyflat-delete-dialog.component.ts